import loadable from '@loadable/component';

import { Heading } from '@simplywallst/ui-core/next';

import { useManualPortfolioContext } from '../../../PortfolioManual';

import { IncompleteManualPortfolioWarning } from '../IncompleteManualPortfolioWarning';

import type { Portfolio } from '@/hooks/portfolio/usePortfolio';
import { usePortfolioType } from '../../../HoldingsTable/hooks';

const TransactionsMetrics = loadable(() => import('./components'), {
  resolveComponent: (c) => c.TransactionsMetrics,
});

const Metrics = loadable(() => import('./components'), {
  resolveComponent: (c) => c.Metrics,
});

interface Props {
  portfolio: Portfolio;
}

export const OverviewHeader = ({ portfolio }: Props) => {
  const { updatePortfolio } = useManualPortfolioContext();

  const portfolioType = usePortfolioType(portfolio);

  return (
    <div className="grid w-full max-w-full overflow-hidden rounded-t-x1 p-x1 [background:linear-gradient(rgba(0,0,0,0)_0%,rgba(0,0,0,.15)_25%,rgba(0,0,0,0)_100%)] md:p-x2 lg:px-x3 lg:pt-x1_5">
      <div className="grid grid-cols-[auto] items-center gap-x1 md:grid-cols-[max-content_auto] md:gap-x2">
        <Heading
          as="h2"
          size="small"
          className="px-x1 pt-x1 text-solid md:px-0 md:pt-0"
        >
          Performance vs market
        </Heading>
        {portfolioType === 'manual-portfolio' && (
          <IncompleteManualPortfolioWarning
            holdings={portfolio.holdings}
            onClick={() => updatePortfolio({ portfolioId: portfolio.id })}
          />
        )}
      </div>
      <div className="mt-x2 grid min-h-[45px] lg:min-h-[50px]">
        {portfolioType === 'transaction-portfolio' ? (
          <TransactionsMetrics portfolio={portfolio} />
        ) : (
          <Metrics portfolio={portfolio} />
        )}
      </div>
    </div>
  );
};

export const DemoOverviewHeader = ({ portfolio }: Props) => {
  const portfolioType = usePortfolioType(portfolio);

  return (
    <div className="grid w-full max-w-full overflow-hidden rounded-t-x1 p-x1 [background:linear-gradient(rgba(0,0,0,0)_0%,rgba(0,0,0,.15)_25%,rgba(0,0,0,0)_100%)] md:p-x2 lg:px-x3 lg:pt-x1_5">
      <div className="grid grid-cols-[auto] items-center gap-x1 md:grid-cols-[max-content_auto] md:gap-x2">
        <Heading
          as="h2"
          size="small"
          className="px-x1 pt-x1 text-solid md:px-0 md:pt-0"
        >
          Performance vs market
        </Heading>
      </div>
      <div className="mt-x2 grid min-h-[45px] lg:min-h-[50px]">
        {portfolioType === 'transaction-portfolio' ? (
          <TransactionsMetrics portfolio={portfolio} />
        ) : (
          <Metrics portfolio={portfolio} />
        )}
      </div>
    </div>
  );
};
